import { render, staticRenderFns } from "./config015-a0-dianji.vue?vue&type=template&id=8722d5ce&"
import script from "./config015-a0-dianji.vue?vue&type=script&lang=js&"
export * from "./config015-a0-dianji.vue?vue&type=script&lang=js&"
import style0 from "./config015-a0-dianji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports